import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.membersList>>;

export const createFetchOrgMembersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getOrgMembers({
          oid: organizationId,
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
          teamsSlugFilter: params.teamsSlugFilter,
        }),
        signal,
      ),
    );
